// extracted by mini-css-extract-plugin
module.exports = {"page":"AppPagination_page__10ueV","disabled":"AppPagination_disabled__3qGEn","selected":"AppPagination_selected__3bVR1","ellipsis":"AppPagination_ellipsis__1J-oi"};